export const WHITE = '#FFFFFF';
export const BLACK = '#000000';
export const GRAY = '#737373';

// Neutral gray gradient from https://tailwindcss.com/docs/customizing-colors
export const GRAY_GRADIENT = {
  50: '#fafafa',
  100: '#f5f5f5',
  200: '#e5e5e5',
  300: '#d4d4d4',
  400: '#a3a3a3',
  500: GRAY,
  600: '#525252',
  700: '#404040',
  800: '#262626',
  900: '#171717',
  950: '#0a0a0a',
};

// BBW COLOR PALETTE
export const ICE = '#F0F3F4';
export const SAGE = '#87BCBF';
export const SLATE = '#6E8CA0';
export const RAIN = '#324755';
export const WHOOP = '#500000';
export const ONYX = '#1B1C20';
export const SUNSHINE = '#FCC931';
export const FOSSIL = '#C8D1D3';
export const SAND = '#B9B0A2';
export const SNOW = '#FFFFFF';
export const RADIAL = '#FCF3F2';

// BBW COLOR PALETTE GRADIENTS
export const SAGE_GRADIENT = {
  50: '#f3f8f8',
  100: '#e7f1f2',
  200: '#cfe4e5',
  300: '#b7d7d9',
  400: '#9fc9cc',
  500: SAGE,
  600: '#6b9395',
  700: '#506c6e',
  800: '#364849',
  900: '#1e2627',
  950: '#131717',
};

export const PRIMARY = RAIN;

export const LOW_RISK = '#21EA59';
export const MODERATE_LOW_RISK = '#D4e233';
export const MODERATE_RISK = '#EECD1E';
export const MODERATE_HIGH_RISK = '#E77D41';
export const HIGH_RISK = '#DA3B31';

export const colors = {
  white: {
    DEFAULT: WHITE,
  },
  black: {
    DEFAULT: BLACK,
  },
  fossil: {
    DEFAULT: FOSSIL,
  },
  gray: {
    DEFAULT: GRAY,
    ...GRAY_GRADIENT,
  },
  ice: {
    DEFAULT: ICE,
  },
  onyx: {
    DEFAULT: ONYX,
  },
  primary: {
    DEFAULT: PRIMARY,
  },
  rain: {
    DEFAULT: RAIN,
  },
  sage: {
    DEFAULT: SAGE,
    ...SAGE_GRADIENT,
  },
  sand: {
    DEFAULT: SAND,
  },
  slate: {
    DEFAULT: SLATE,
  },
  snow: {
    DEFAULT: SNOW,
  },
  sunshine: {
    DEFAULT: SUNSHINE,
  },
  whoop: {
    DEFAULT: WHOOP,
    200: '#EFE7E7',
  },

  // Risk colors
  low: {
    DEFAULT: LOW_RISK,
    text: '#1B9D3F', // Text colors are designed to be readable when font is colored
  },
  moderateLow: {
    DEFAULT: MODERATE_LOW_RISK,
    text: '#B5C12C',
  },
  moderate: {
    DEFAULT: MODERATE_RISK,
    text: '#DFC01C',
  },
  moderateHigh: {
    DEFAULT: MODERATE_HIGH_RISK,
  },
  high: {
    DEFAULT: HIGH_RISK,
  },
};
